/* eslint-disable no-console */
/*
 * EasyBarn — Custom Hardware cart enhancer
 * ----------------------------------------
 * Decorates the "Custom Hardware" line item (product 9508796956904) in the
 * cart drawer and on /cart so the customer sees:
 *   - Strikethrough of the original R 1,699.00 ↓ R 0.00
 *   - A "FREE Hardware Included With Custom Barn Door Purchase" badge
 * Mirrors how a Shopify automatic-discount line renders, but is purely
 * presentational (the variant is already priced at R0).
 */
(function () {
  'use strict';

  var HARDWARE_PRODUCT_ID = '9508796956904';
  var BADGE_TEXT          = 'FREE Hardware Included With Custom Barn Door Purchase';
  var STRIKE_PRICE_HTML   = '<del>R&nbsp;1,699.00</del>&nbsp;<ins>R&nbsp;0.00</ins>';
  var ENHANCED_ATTR       = 'data-ebcd-hw-enhanced';

  function buildBadgeNode() {
    var ul = document.createElement('ul');
    ul.className = 't4s-cart_discount_price ebcd-free-hw-badge';
    ul.style.cssText = 'list-style:none;padding:0;margin:6px 0 0;';
    ul.innerHTML =
      '<li class="t4s-order-discount__item" style="display:inline-flex;align-items:center;gap:6px;font-size:0.85em;color:#c41e3a;font-weight:600;line-height:1.3;">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">' +
          '<path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/>' +
        '</svg>' +
        BADGE_TEXT +
      '</li>';
    return ul;
  }

  function enhanceLine(line) {
    if (line.getAttribute(ENHANCED_ATTR)) return;

    var priceEl = line.querySelector('.t4s-cart_price, .t4s-page_cart__price, .t4s-cart-item__price, .cart-item__price, [data-cart-price]');
    if (priceEl && !priceEl.querySelector('del')) {
      priceEl.innerHTML = STRIKE_PRICE_HTML;
    }

    if (!line.querySelector('.ebcd-free-hw-badge')) {
      var anchor = line.querySelector('.t4s-mini_cart__meta, .t4s-page_cart__infos, .t4s-cart-item__meta, .cart-item__details, .t4s-mini_cart__info');
      if (!anchor) {
        anchor = priceEl ? priceEl.parentNode : null;
      }
      if (!anchor) {
        var titleLink = line.querySelector('a[href*="/products/custom-hardware"]');
        anchor = titleLink ? titleLink.parentNode : null;
      }
      if (anchor) {
        anchor.appendChild(buildBadgeNode());
      }
    }

    line.setAttribute(ENHANCED_ATTR, '1');
  }

  function sweep() {
    // 1. Match by data-pid (cart drawer pattern: data-pid="9508796956904")
    document.querySelectorAll('[data-cart-item][data-pid="' + HARDWARE_PRODUCT_ID + '"], [data-product-id="' + HARDWARE_PRODUCT_ID + '"]').forEach(enhanceLine);

    // 2. Cart page pattern (data-cart-item="" with no pid): match by product handle in the link
    document.querySelectorAll('[data-cart-item]').forEach(function (line) {
      if (line.querySelector('a[href*="/products/custom-hardware"]')) {
        enhanceLine(line);
      }
    });

    // 3. Generic fallback: any container with a custom-hardware link inside that hasn't been enhanced
    document.querySelectorAll('.t4s-page_cart__item, .t4s-mini_cart__item, .cart-item').forEach(function (line) {
      if (line.querySelector('a[href*="/products/custom-hardware"]')) {
        enhanceLine(line);
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      sweep();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('cart:refresh',  schedule);
  document.addEventListener('cart:updated',  schedule);
  document.addEventListener('cart:rerender', schedule);
  document.addEventListener('t4s:cart:reload', schedule);
})();
